import { appendFormData, Builder, getHeaders, getQueryString } from './utils';
import { DataApiInputParams } from 'src/types/api';

export default (builder: Builder) => {
  return {
    restoreRevision: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let formData = appendFormData(arg.params);
        let url = `expert-advisor/canvas-revisions`;
        return fetchWithBQ({
          url: url,
          method: 'PATCH',
          body: formData,
          ...getHeaders(url, formData)
        });
      }
    }),
    updateCanvasContent: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let formData = appendFormData(arg.params);
        let url = `expert-advisor/canvas-revisions`;
        return fetchWithBQ({
          url: url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      }
    }),
    getCanvasByRevision: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `expert-advisor/canvas-revisions?${getQueryString(
          arg.params
        )}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    })
  };
};
